export default [
    {
        path: '/teacherContracts',
        name: 'teacherContracts',
        component: () => import ('./pages/Index')
    },
]